export const availablePondCycles = ({ values, pondCycles }) => {
  const pondCyclesInUse = values.populations.map((pop) => pop.cycle);

  const pondCyclesFiltered = pondCycles.filter((pondCycle) => !pondCyclesInUse.includes(pondCycle.id));

  return pondCyclesFiltered;
};
